// Skype Notification types:
// CALL: Notification on incoming call
// IM: Notification on unread message
// SUMMARY: Notification on summary of unread messages (generally treated the same as IM)
export var CALL_NOTIFICATION_TYPE = 'Calling';
export var IM_NOTIFICATION_TYPE = 'UnreadMessage';
export var SUMMARY_NOTIFICATION_TYPE = 'Summary';
//# sourceMappingURL=constants.js.map